export const agencyDashboardRoutes = {
  default:'agency_dashboard',
  main: 'agency-dashboard-main',
}
